import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';


import { registerComponent } from '../components-front';
document.addEventListener('DOMContentLoaded', ()=> {
    
    registerComponent('testimonial-revolving-autoplay-carousel', _ => {
        document.querySelectorAll('.testimonial-revolving-autoplay-carousel-wrapper').forEach(carouselWrapper => {
            const carousel = carouselWrapper.querySelector('.testimonial-revolving-autoplay-carousel')
            const cols = carousel.dataset.cols || 2
    
            const progressCircle = carouselWrapper.querySelector(".autoplay-progress svg");
            const progressContent = carouselWrapper.querySelector(".autoplay-progress span");
    
            /** @var {HTMLDivElement} prev */
            const prev = carouselWrapper.querySelector('.prev')
            /** @var {HTMLDivElement} next */
            const next = carouselWrapper.querySelector('.next')
    
            const swiper = new Swiper(carousel, {
                modules: [Autoplay, Navigation, Pagination],
                direction: "horizontal",
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 600,
                observer: false,
                observeParents: false,
                resizeObserver: false,
                loop: true,
                autoplay: { delay: 5500, disableOnInteraction: false },
                navigation: { nextEl: next, prevEl: prev },
                on: {
                    autoplayTimeLeft(s, time, progress) {
                        if (progressCircle) progressCircle.style.setProperty("--progress", 1 - progress);
                        if (progressContent) progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                    },
                },
            });
        })
    })
})